import React from "react";
import "./SkillPage.css";

const SkillPage = () => {
  return (
    <div className="skill-container">
      <div className="skill-left">
        <div className="skill-header">
          <span>ski</span>lls
        </div>
        <p>
        Frameworks are optional—knowledge and skill are not.
        </p>
      </div>
      <div className="skill-right">
  <div id="myCanvasContainer">
    <canvas width="600" height="600" id="myCanvas"></canvas>
  </div>
  <div id="tags">
    <ul>
      <li><a href="/skills">Java</a></li>
      <li><a href="/skills">Python</a></li>
      <li><a href="/skills">Node.js</a></li>
      <li><a href="/skills">Express.js</a></li>
      <li><a href="/skills">SQL</a></li>
      <li><a href="/skills">MongoDB</a></li>
      <li><a href="/skills">REST API</a></li>
      <li><a href="/skills">GitHub</a></li>
      <li><a href="/skills">Postman</a></li>
      <li><a href="/skills">Docker</a></li>
      <li><a href="/skills">Firebase</a></li>
      <li><a href="/skills">IntelliJ IDEA</a></li>
      <li><a href="/skills">Eclipse</a></li>
      <li><a href="/skills">NetBeans</a></li>
      <li><a href="/skills">HTML</a></li>
      <li><a href="/skills">CSS</a></li>
      <li><a href="/skills">JavaScript</a></li>
      <li><a href="/skills">ES6+</a></li>
      <li><a href="/skills">React</a></li>
      <li><a href="/skills">PostGreSql</a></li>
      <li><a href="/skills">VS Code</a></li>
      <li><a href="/skills">Flask</a></li>
      <li><a href="/skills">Django</a></li>
      <li><a href="/skills">NumPy</a></li>
      <li><a href="/skills">Pandas</a></li>
      <li><a href="/skills">Requests</a></li>
    </ul>
  </div>
</div>

    </div>
  );
};

export default SkillPage;
